import { MapGeoJsonResponse } from '@tq/ui-components/dist/components/map';

import { apiGet } from 'api';

export const getMapPolygon = (consultationId: number): Promise<MapGeoJsonResponse> =>
  apiGet<MapGeoJsonResponse>(`consultations/${consultationId}/polygon`).then((response) => {
    if (response?.geoJson?.features?.length && !response.geoJson.features[0].id) {
      response.geoJson.features[0].id = consultationId.toString();
    }
    return response;
  });
